import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useState } from "react";

import { trackEvent } from "utils/tracking";

import LauraVIPCard from "../LauraVIPCard";
import TaylorVaultCard from "../TaylorVaultCard";
import UGCTrainingCard from "../UGCTrainingCard";

const CARDS = [<UGCTrainingCard />, <LauraVIPCard />, <TaylorVaultCard />];
const INTERVAL_MS = 10000;

const CARD_NAMES = [
  "UGC Training",
  "Laura VIP Coaching",
  "Taylor Creator Partnership Vault",
];

const PartnerOffersCarousel = () => {
  const displayPartnerOfferTracking = (activeIndex: number) => {
    trackEvent("Partner Offers Displayed", {
      activeOffer: CARD_NAMES[activeIndex],
    });
  };
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % CARDS.length);
    }, INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box>
      {CARDS[activeIndex]}

      <Box display="flex" justifyContent="center" gap={1} sx={{ mt: 1.5 }}>
        {CARDS.map((_, i) => (
          <Box
            key={i}
            onClick={() => {
              setActiveIndex(i);
              displayPartnerOfferTracking(i);
            }}
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: i === activeIndex ? "primary.main" : grey[500],
              cursor: "pointer",
              transition: "background-color 0.3s",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PartnerOffersCarousel;
